import React, { Component } from 'react';
import Filter from '../ChartFilter';
import PieChart from './PieChart';
import HistogramChart from './HistogramChart';
import DoubleAnnulusChart from './DoubleAnnulusChart';
import { genModules } from '../../../constants';

const Charts = {
    'pie': PieChart,
    'doubleAnnulus': DoubleAnnulusChart,
    'histogram': HistogramChart,
};

class ChartsCollection extends Component {
    constructor(props) {
        super(props);
        this.initCharts();
        this.state = {
            load: null
        };
    }

    initCharts = () => {
        const { auth = true, charts } = this.props;
        this.charts = genModules(charts, auth);
    }

    search = () => {
        this.initCharts();
        this.setState({ load: {} });
    }

    render() {
        const { countType, searchParams, clientHeight, onChange } = this.props;
        const { load } = this.state;
        const height = (clientHeight - 72 - 54 - 40 - 56) / 2;
        const charts = this.charts.map(item => {
            const { key, title, chartTitle, type, queryUrl, exportUrl } = item;
            const Content = Charts[type];
            return (
                <Content
                    key={key}
                    load={load}
                    height={height}
                    title={title}
                    filename={title}
                    chartTitle={chartTitle}
                    countType={countType}
                    searchParams={searchParams}
                    queryUrl={queryUrl}
                    exportUrl={exportUrl}
                />
            );
        });
        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    searchParams={searchParams}
                    onChange={onChange}
                />
                <div className="chart-gallery">
                    {charts}
                </div>
            </div>
        );
    }
}

export default ChartsCollection;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/components/ChartsCollection/index.js